module.exports = __webpack_public_path__ + "static/media/snapshot-device.d5b31da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ittybittyapps/snapshot-device.png
// module id = 241
// module chunks = 0